module.exports = __webpack_public_path__ + "static/work_stereosun-a48993a8ed2d0994cc699cd8b3b888c3.jpg";